package org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_chart.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.jetbrains.compose.web.css.backgroundImage
import org.jetbrains.compose.web.css.backgroundPosition
import org.jetbrains.compose.web.css.backgroundRepeat
import org.jetbrains.compose.web.css.backgroundSize
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width

@Composable
fun TopDashboardChartToolbar(
    onBackClick: () -> Unit,
    name: String?,
)
{
    Row(
        modifier = Modifier,
        verticalAlignment = Alignment.CenterVertically
    )
    {
        CustomIcon(
            modifier = Modifier
                .margin(right = Dimen.mediumPadding),
            icon = Res.PathIcon.leftArrow,
            iconColor = Theme.ActionActive.hex,
            onIconClick = {
                onBackClick()
            }
        )

        MediumContentTitle(
            title = name?:""
        )
        Row(
            verticalAlignment = Alignment.Top
        )
        {

            Box(
                modifier = Modifier
                    .attrsModifier {
                        style {
                            width(Dimen.highMediumIconSize.px)
                            height(Dimen.highMediumIconSize.px)
                            backgroundPosition("center")
                            backgroundRepeat("no-repeat")
                            backgroundImage(Res.PathIcon.cloud)
                        }
                    }
            )


            SpanText(
                text ="17" ,
                modifier = Modifier
                    .margin(left =(-Dimen.smallPadding.value.toInt()).px)
                    .fontSize(FontSizes.semiMediumFontSize)
                    .color(Theme.DarkGrey.rgb)
                    .fontFamily(FontFamily.Jakarta)

            )
        }

    }


}